import 'jquery';
import 'appdevresources/jquery-ui';
import '@fortawesome/fontawesome-free/js/all.min';
import 'bootstrap';
import 'popper.js';
import 'trumbowyg';
import 'trumbowyg/plugins/cleanpaste/trumbowyg.cleanpaste';
import 'datatables.net-fixedheader-bs4';
import 'select2';
import {unloadSpinner} from 'appdevresources/common';

// This is here to ensure that jQuery is available outside of webpack.
if (typeof global.jQuery === 'undefined') {
    global.$ = global.jQuery = jQuery;
}
import 'petition-js/searchBar.js';
import 'appdevresources/navigation-menu-builder';
import { initializeImpersonateUser } from 'appdevresources/common';

global.dd = window.console.log;

$(window).on('pageshow', () => {
    unloadSpinner();
    $('.loading').remove();
});

$(function() {
    $('input[type="checkbox"][data-toggle="toggle"]').addClass('d-none').toggleSwitch();
    initializeImpersonateUser();
});
